import { generateIconComponent } from './icons.utils';

export const CheckmarkLightIcon = generateIconComponent({
    name: 'CheckmarkLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M21.8408 4.37009L8.42154 17.7919L2.16106 11.5289C1.66508 11.0329 0.865435 11.0329 0.371985 11.5289C-0.123995 12.0224 -0.123995 12.822 0.371985 13.318L7.52827 20.4743C7.77373 20.7223 8.09764 20.8462 8.42154 20.8462C8.74545 20.8462 9.06935 20.7223 9.31734 20.4743L23.6299 6.15916C24.1234 5.66571 24.1234 4.86354 23.6299 4.37009C23.1365 3.87664 22.3343 3.87664 21.8408 4.37009Z" />
    ),
});
